document.addEventListener('DOMContentLoaded', function() {
    const dropdownButtons = document.querySelectorAll('[data-dropdown-toggle]');
    
    dropdownButtons.forEach(button => {
        // Estado inicial
        button.setAttribute('aria-expanded', 'false');
        
        // Observar cambios en la visibilidad del dropdown
        const dropdownId = button.getAttribute('data-dropdown-toggle');
        const dropdown = document.getElementById(dropdownId);
        
        if (dropdown) {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        const isHidden = dropdown.classList.contains('hidden');
                        button.setAttribute('aria-expanded', !isHidden);
                    }
                });
            });
            
            observer.observe(dropdown, {
                attributes: true,
                attributeFilter: ['class']
            });
        }
    });
});


document.addEventListener('DOMContentLoaded', function() {
    // Obtener la URL actual
    const currentPath = window.location.pathname;
    // Comprobar si estamos en la página del blog
    if (currentPath === '/blog' || currentPath.startsWith('/blog/') || currentPath === '/en/blog-en' || currentPath.startsWith('/en/blog-en/') || currentPath === '/eu/blog-eu' || currentPath.startsWith('/eu/blog-eu/') || currentPath === '/fr/blog-fr' || currentPath.startsWith('/fr/blog-fr/')) {
        // Seleccionar el enlace del blog y añadir la clase o estilo
        const blogLink = document.getElementById('mega-menu-blog-button');
        if (blogLink) {
            blogLink.style.backgroundColor = '#ECD8E3';
            // Alternativa: añadir una clase
            // blogLink.classList.add('active');
        }
    }

    if (currentPath === '/agenda' || currentPath.startsWith('/agenda/') || currentPath === '/en/agenda-en' || currentPath.startsWith('/en/agenda-en/') || currentPath === '/eu/agenda-eu' || currentPath.startsWith('/eu/agenda-eu/') || currentPath === '/fr/agenda-fr' || currentPath.startsWith('/fr/agenda-fr/')) {
        // Seleccionar el enlace del blog y añadir la clase o estilo
        const eventosLink = document.getElementById('mega-menu-eventos-button');
        if (eventosLink) {
            eventosLink.style.backgroundColor = '#ECD8E3';
            // Alternativa: añadir una clase
            // eventosLink.classList.add('active');
        }
    }
});

// Global Search Functionality
document.addEventListener('DOMContentLoaded', function() {
    const searchInput = document.getElementById('global-search-input');
    const searchResults = document.getElementById('search-results');
    const searchLoading = document.getElementById('search-loading');
    const noResults = document.getElementById('no-results');
    const initialMessage = document.getElementById('initial-message');
    
    if (!searchInput) return;
    
    let searchTimeout;
    
    searchInput.addEventListener('input', function() {
        const searchTerm = this.value.trim();
        
        // Clear previous timeout
        clearTimeout(searchTimeout);
        
        // Reset states
        searchLoading.classList.add('hidden');
        noResults.classList.add('hidden');
        
        if (searchTerm.length < 2) {
            // Show initial message
            searchResults.innerHTML = '';
            initialMessage.classList.remove('hidden');
            return;
        }
        
        // Hide initial message
        initialMessage.classList.add('hidden');
        
        // Show loading with debounce
        searchTimeout = setTimeout(() => {
            performSearch(searchTerm);
        }, 300);
    });
    
    function performSearch(searchTerm) {
        searchLoading.classList.remove('hidden');
        searchResults.innerHTML = '';
        
        // AJAX request
        fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'themebloques_search',
                search_term: searchTerm
            })
        })
        .then(response => response.json())
        .then(data => {
            searchLoading.classList.add('hidden');
            
            if (data.success && data.data.length > 0) {
                displayResults(data.data);
            } else {
                noResults.classList.remove('hidden');
            }
        })
        .catch(error => {
            console.error('Search error:', error);
            searchLoading.classList.add('hidden');
            noResults.classList.remove('hidden');
        });
    }
    
    function displayResults(results) {
        const resultsHTML = results.map(result => {
            const typeColor = getTypeColor(result.type);
            const hasImage = result.image && result.image.trim() !== '';
            
            return `
                <a href="${result.url}" class="block p-4 bg-white rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors duration-200">
                    <div class="flex items-start space-x-4">
                        ${hasImage ? `<img src="${result.image}" alt="${result.title}" class="w-16 h-16 object-cover rounded-lg flex-shrink-0">` : ''}
                        <div class="flex-1 min-w-0">
                            <div class="flex items-center space-x-2 mb-1">
                                <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${typeColor}">
                                    ${result.type}
                                </span>
                            </div>
                            <h3 class="text-sm font-medium text-gray-900 truncate">${result.title}</h3>
                            <p class="text-sm text-gray-500 mt-1 line-clamp-2">${result.excerpt}</p>
                        </div>
                        <svg class="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                        </svg>
                    </div>
                </a>
            `;
        }).join('');
        
        searchResults.innerHTML = resultsHTML;
    }
    
    function getTypeColor(type) {
        switch(type) {
            case 'Información':
                return 'bg-blue-100 text-blue-800';
            case 'Blog':
                return 'bg-green-100 text-green-800';
            case 'Evento':
                return 'bg-purple-100 text-purple-800';
            case 'Establecimiento':
                return 'bg-orange-100 text-orange-800';
            default:
                return 'bg-gray-100 text-gray-800';
        }
    }
    
    // Focus search input when dropdown opens
    const searchButton = document.getElementById('mega-menu-search-button');
    if (searchButton) {
        searchButton.addEventListener('click', function() {
            setTimeout(() => {
                if (searchInput) {
                    // Detectar iOS
                    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                                  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
                    
                    if (isIOS) {
                        // En iOS, usar click() para activar el teclado
                        searchInput.click();
                        // Fallback con focus después de un delay más largo
                        setTimeout(() => {
                            searchInput.focus();
                        }, 200);
                    } else {
                        searchInput.focus();
                    }
                }
            }, 100);
        });
    }
});

// CONFIGURADOR DE VIAJE
document.addEventListener('DOMContentLoaded', function() {
    const configuradorForm = document.getElementById('configurador-form');
    const configuradorResultados = document.getElementById('configurador-resultados');
    const configuradorFiltrosActivos = document.getElementById('configurador-filtros-activos');
    
    if (!configuradorForm) return;
    
    let filtrosActivos = {
        tipo_viaje: '',
        estacion: '',
        categorias: []
    };
    
    // Manejar selección de tipo de viaje
    document.querySelectorAll('.tipo-viaje-btn').forEach(btn => {
        btn.addEventListener('click', function() {
            document.querySelectorAll('.tipo-viaje-btn').forEach(b => b.classList.remove('active'));
            
            if (filtrosActivos.tipo_viaje === this.dataset.tipo) {
                filtrosActivos.tipo_viaje = '';
            } else {
                this.classList.add('active');
                filtrosActivos.tipo_viaje = this.dataset.tipo;
            }
            
            actualizarFiltros();
        });
    });
    
    // Manejar selección de estación
    document.querySelectorAll('.estacion-btn').forEach(btn => {
        btn.addEventListener('click', function() {
            document.querySelectorAll('.estacion-btn').forEach(b => b.classList.remove('active'));
            
            if (filtrosActivos.estacion === this.dataset.estacion) {
                filtrosActivos.estacion = '';
            } else {
                this.classList.add('active');
                filtrosActivos.estacion = this.dataset.estacion;
            }
            
            actualizarFiltros();
        });
    });
    
    // Manejar selección de categorías
    const categoriaBtns = configuradorForm.querySelectorAll('.categoria-btn');
    categoriaBtns.forEach(btn => {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            
            const categoria = this.dataset.categoria;
            
            if (this.classList.contains('active')) {
                if (filtrosActivos.categorias.includes(categoria)) {
                    filtrosActivos.categorias = filtrosActivos.categorias.filter(c => c !== categoria);
                }
            } else {
                if (!filtrosActivos.categorias.includes(categoria)) {
                    filtrosActivos.categorias.push(categoria);
                }
            }
            
            this.classList.toggle('active');
            
            actualizarFiltros();
        });
    });
    
    // Función para actualizar resultados
    function actualizarFiltros() {
        if (!filtrosActivos.tipo_viaje && !filtrosActivos.estacion && filtrosActivos.categorias.length === 0) {
            mostrarEstadoInicial();
            return;
        }
        
        // Mostrar loading
        mostrarLoading();
        
        // Preparar datos para AJAX
        const formData = new FormData();
        formData.append('action', 'configurador_get_results');
        formData.append('_ajax_nonce', window.configurador_vars?.nonce || '');
        formData.append('tipo_viaje', filtrosActivos.tipo_viaje);
        formData.append('estacion', filtrosActivos.estacion);
        
        // Añadir categorías
        filtrosActivos.categorias.forEach(categoria => {
            formData.append('categorias[]', categoria);
        });
        
        // Realizar petición AJAX
        fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                mostrarResultados(data.data.resultados);
                mostrarFiltrosActivos(data.data.filtros);
            } else {
                mostrarError(data.data.message || 'Error al cargar resultados');
            }
        })
        .catch(error => {
            console.error('Error:', error);
            mostrarError('Error de conexión');
        });
    }
    
    function mostrarEstadoInicial() {
        if (configuradorResultados) {
            configuradorResultados.innerHTML = `
                <div class="text-center py-12">
                    <div class="text-gray-500 mb-4">
                        <svg class="w-16 h-16 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                        </svg>
                    </div>
                    <h3 class="text-xl font-semibold text-gray-900 mb-2">Configura tu viaje personalizado</h3>
                    <p class="text-gray-600">Selecciona tus preferencias en el panel lateral para descubrir experiencias únicas en San Sebastián</p>
                </div>
            `;
        }
        
        if (configuradorFiltrosActivos) {
            configuradorFiltrosActivos.innerHTML = '';
        }
    }
    
    function mostrarLoading() {
        if (configuradorResultados) {
            configuradorResultados.innerHTML = `
                <div class="text-center py-12">
                    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                    <p class="text-gray-600">Buscando experiencias personalizadas...</p>
                </div>
            `;
        }
    }
    
    function mostrarResultados(resultados) {
        if (!configuradorResultados) return;
        
        if (resultados.length === 0) {
            configuradorResultados.innerHTML = `
                <div class="text-center py-12">
                    <div class="text-gray-400 mb-4">
                        <svg class="w-16 h-16 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 15c-2.34 0-4.29-1.009-5.824-2.562M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"></path>
                        </svg>
                    </div>
                    <h3 class="text-xl font-semibold text-gray-900 mb-2">No se encontraron resultados</h3>
                    <p class="text-gray-600">Prueba con diferentes filtros para encontrar más experiencias</p>
                </div>
            `;
            return;
        }
        
        const resultadosHTML = resultados.map(resultado => `
            <div class="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden hover:shadow-md transition-shadow duration-200">
                <div class="p-6">
                    <h3 class="text-lg font-semibold text-gray-900 mb-2">
                        <a href="${resultado.url}" class="hover:text-blue-600 transition-colors duration-200">
                            ${resultado.titulo}
                        </a>
                    </h3>
                    <p class="text-gray-600 text-sm mb-4">${resultado.excerpt}</p>
                    <a href="${resultado.url}" class="inline-flex items-center text-blue-600 hover:text-blue-800 text-sm font-medium transition-colors duration-200">
                        Ver más
                        <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                        </svg>
                    </a>
                </div>
            </div>
        `).join('');
        
        configuradorResultados.innerHTML = `
            <div class="mb-6">
                <h2 class="text-2xl font-bold text-gray-900 mb-2">Experiencias recomendadas</h2>
                <p class="text-gray-600">Encontramos ${resultados.length} experiencias que coinciden con tus preferencias</p>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                ${resultadosHTML}
            </div>
        `;
    }
    
    function mostrarFiltrosActivos(filtros) {
        if (!configuradorFiltrosActivos) return;
        
        let filtrosHTML = [];
        
        // Tipo de viaje
        if (filtros.tipo_viaje) {
            const tipoLabels = {
                'solitario': 'En solitario',
                'pareja': 'En pareja', 
                'familia': 'En familia',
                'grupo': 'En grupo'
            };
            filtrosHTML.push(`
                <span class="inline-flex items-center px-3 py-1 rounded-full text-sm bg-blue-100 text-blue-800">
                    ${tipoLabels[filtros.tipo_viaje] || filtros.tipo_viaje}
                    <button type="button" class="ml-2 text-blue-600 hover:text-blue-800" onclick="limpiarTipoViaje()">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                    </button>
                </span>
            `);
        }
        
        // Categorías
        filtros.categorias.forEach(categoria => {
            const categoriaLabels = {
                'calles_con_historia': 'Calles con historia',
                'vistas_y_naturaleza': 'Vistas y naturaleza',
                'escapada_a_la_playa': 'Escapada a la playa',
                'relax_y_desconexion': 'Relax y desconexión',
                'historia_y_patrimonio': 'Historia y patrimonio',
                'mas_alla_de_la_ciudad': 'Más allá de la ciudad',
                'sabores_locales': 'Sabores locales'
            };
            
            filtrosHTML.push(`
                <span class="inline-flex items-center px-3 py-1 rounded-full text-sm bg-green-100 text-green-800">
                    ${categoriaLabels[categoria] || categoria}
                    <button type="button" class="ml-2 text-green-600 hover:text-green-800" onclick="limpiarCategoria('${categoria}')">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                    </button>
                </span>
            `);
        });
        
        // Estación
        if (filtros.estacion) {
            const estacionLabels = {
                'primavera': '🌸 Primavera',
                'verano': '☀️ Verano',
                'otono': '🍂 Otoño',
                'invierno': '❄️ Invierno'
            };
            
            filtrosHTML.push(`
                <span class="inline-flex items-center px-3 py-1 rounded-full text-sm bg-orange-100 text-orange-800">
                    ${estacionLabels[filtros.estacion] || filtros.estacion}
                    <button type="button" class="ml-2 text-orange-600 hover:text-orange-800" onclick="limpiarEstacion()">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                    </button>
                </span>
            `);
        }
        
        if (filtrosHTML.length > 0) {
            configuradorFiltrosActivos.innerHTML = `
                <div class="flex flex-wrap items-center gap-2 mb-4">
                    <span class="text-sm font-medium text-gray-700 mr-2">Filtros activos:</span>
                    ${filtrosHTML.join('')}
                    <button type="button" class="text-sm text-red-600 hover:text-red-800 ml-2" onclick="limpiarTodosFiltros()">
                        Limpiar todo
                    </button>
                </div>
            `;
        } else {
            configuradorFiltrosActivos.innerHTML = '';
        }
    }
    
    function mostrarError(mensaje) {
        if (configuradorResultados) {
            configuradorResultados.innerHTML = `
                <div class="text-center py-12">
                    <div class="text-red-500 mb-4">
                        <svg class="w-16 h-16 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                    </div>
                    <h3 class="text-xl font-semibold text-gray-900 mb-2">Error</h3>
                    <p class="text-gray-600">${mensaje}</p>
                </div>
            `;
        }
    }
    
    // Funciones globales para limpiar filtros
    window.limpiarTipoViaje = function() {
        filtrosActivos.tipo_viaje = '';
        document.querySelectorAll('.tipo-viaje-btn').forEach(btn => btn.classList.remove('active'));
        actualizarFiltros();
    };
    
    window.limpiarEstacion = function() {
        filtrosActivos.estacion = '';
        document.querySelectorAll('.estacion-btn').forEach(btn => btn.classList.remove('active'));
        actualizarFiltros();
    };
    
    window.limpiarCategoria = function(categoria) {
        filtrosActivos.categorias = filtrosActivos.categorias.filter(c => c !== categoria);
        const btn = configuradorForm.querySelector(`[data-categoria="${categoria}"]`);
        if (btn) btn.classList.remove('active');
        actualizarFiltros();
    };
    
    window.limpiarTodosFiltros = function() {
        filtrosActivos = {
            tipo_viaje: '',
            estacion: '',
            categorias: []
        };
        
        // Limpiar UI
        document.querySelectorAll('.tipo-viaje-btn').forEach(btn => btn.classList.remove('active'));
        document.querySelectorAll('.estacion-btn').forEach(btn => btn.classList.remove('active'));
        document.querySelectorAll('.categoria-btn').forEach(btn => btn.classList.remove('active'));
        
        mostrarEstadoInicial();
    };
    
    // Función para leer parámetros de URL
    function getURLParameter(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }
    
    // Inicializar con parámetros de URL si existen
    function inicializarConParametros() {
        const categoriaURL = getURLParameter('categoria');
        const tipoViajeURL = getURLParameter('tipo_viaje');
        let parametrosEncontrados = false;
        
        // Preseleccionar tipo de viaje si existe en URL
        if (tipoViajeURL) {
            const tipoViajeBtn = document.querySelector(`[data-tipo="${tipoViajeURL}"]`);
            if (tipoViajeBtn) {
                tipoViajeBtn.classList.add('active');
                filtrosActivos.tipo_viaje = tipoViajeURL;
                parametrosEncontrados = true;
            }
        }
        
        // Preseleccionar categoría si existe en URL
        if (categoriaURL) {
            const categoriaBtn = document.querySelector(`[data-categoria="${categoriaURL}"]`);
            if (categoriaBtn) {
                categoriaBtn.classList.add('active');
                filtrosActivos.categorias.push(categoriaURL);
                parametrosEncontrados = true;
            }
        }
        
        // Si hay parámetros, actualizar resultados
        if (parametrosEncontrados) {
            actualizarFiltros();
        } else {
            // Si no hay parámetros, mostrar estado inicial
            mostrarEstadoInicial();
        }
    }
    
    // Inicializar estado
    inicializarConParametros();
    
    // El calendario ya no existe, se reemplazó por estaciones
});

// FUNCIÓN GLOBAL PARA NAVEGACIÓN AL CONFIGURADOR DESDE HEADER
window.irAlConfigurador = function(categoria = null) {
    let url = '/configurador-de-viaje/';
    let params = [];
    
    // Añadir tipo de viaje si está seleccionado
    if (window.tipoViajeSeleccionadoHeader) {
        params.push('tipo_viaje=' + encodeURIComponent(window.tipoViajeSeleccionadoHeader));
    }
    
    // Añadir categoría si se especifica
    if (categoria) {
        params.push('categoria=' + encodeURIComponent(categoria));
    }
    
    // Construir URL con parámetros
    if (params.length > 0) {
        url += '?' + params.join('&');
    }
    
    window.location.href = url;
};

// FUNCIÓN PARA NAVEGAR AL CONFIGURADOR CON CATEGORÍA DESDE ENLACES DEL MENÚ
window.irAlConfiguradorConCategoria = function(categoria) {
    window.irAlConfigurador(categoria);
};

// FUNCIÓN PARA SELECCIONAR CATEGORÍA EN HEADER CON ESTADO VISUAL
window.seleccionarCategoriaHeader = function(elemento, categoria) {
    // Limpiar estados activos anteriores
    document.querySelectorAll('.categoria-header-link').forEach(link => {
        link.classList.remove('bg-blue-100', 'text-blue-700', 'font-semibold');
        link.classList.add('text-gray-700');
    });
    
    // Añadir estado activo al elemento seleccionado
    elemento.classList.remove('text-gray-700');
    elemento.classList.add('bg-blue-100', 'text-blue-700', 'font-semibold');
    
    // Pequeña pausa para mostrar el estado visual antes de redirigir
    setTimeout(() => {
        window.irAlConfigurador(categoria);
    }, 150);
};

// Variable global para almacenar el tipo de viaje seleccionado en header
window.tipoViajeSeleccionadoHeader = null;

// FUNCIÓN PARA SELECCIONAR TIPO DE VIAJE EN HEADER (SE QUEDA SELECCIONADO)
window.seleccionarTipoViajeHeader = function(elemento, tipoViaje) {
    // Limpiar estados activos anteriores en el mismo dropdown
    const dropdown = elemento.closest('[data-dropdown]') || elemento.closest('.grid');
    if (dropdown) {
        dropdown.querySelectorAll('.tipo-viaje-header-btn').forEach(btn => {
            btn.classList.remove('bg-[#ECD8E3]', 'selected');
            btn.classList.add('bg-[#F7F4F3]');
        });
    }
    
    // Añadir estado seleccionado al elemento (mismo estilo que hover)
    elemento.classList.remove('bg-[#F7F4F3]');
    elemento.classList.add('bg-[#ECD8E3]', 'selected');
    
    // Guardar la selección globalmente
    window.tipoViajeSeleccionadoHeader = tipoViaje;
};

// Funcionalidad del calendario visual
function initDatePicker() {
    let currentDate = new Date();
    let selectedStartDate = null;
    let selectedEndDate = null;
    let isSelectingEndDate = false;
    
    const monthNames = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    
    function renderCalendar() {
        const currentMonthElement = document.getElementById('current-month');
        const calendarGrid = document.getElementById('calendar-grid');
        
        if (!currentMonthElement || !calendarGrid) return;
        
        // Actualizar título del mes
        currentMonthElement.textContent = `${monthNames[currentDate.getMonth()]} ${currentDate.getFullYear()}`;
        
        // Limpiar grid
        calendarGrid.innerHTML = '';
        
        // Obtener primer día del mes y días en el mes
        const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        const daysInMonth = lastDay.getDate();
        const startingDayOfWeek = (firstDay.getDay() + 6) % 7; // Ajustar para que lunes sea 0
        
        // Días del mes anterior
        const prevMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 0);
        for (let i = startingDayOfWeek - 1; i >= 0; i--) {
            const day = prevMonth.getDate() - i;
            const dayElement = createDayElement(day, true);
            calendarGrid.appendChild(dayElement);
        }
        
        // Días del mes actual
        for (let day = 1; day <= daysInMonth; day++) {
            const dayElement = createDayElement(day, false);
            calendarGrid.appendChild(dayElement);
        }
        
        // Días del mes siguiente para completar la grid
        const totalCells = calendarGrid.children.length;
        const remainingCells = 42 - totalCells; // 6 filas x 7 días
        for (let day = 1; day <= remainingCells && remainingCells < 7; day++) {
            const dayElement = createDayElement(day, true, true);
            calendarGrid.appendChild(dayElement);
        }
    }
    
    function createDayElement(day, isOtherMonth, isNextMonth = false) {
        const dayElement = document.createElement('div');
        dayElement.className = 'calendar-day';
        dayElement.textContent = day;
        
        if (isOtherMonth) {
            dayElement.classList.add('other-month');
        }
        
        // Crear fecha para este día
        let dayDate;
        if (isOtherMonth && !isNextMonth) {
            dayDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, day);
        } else if (isOtherMonth && isNextMonth) {
            dayDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, day);
        } else {
            dayDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
        }
        
        // Marcar días seleccionados
        if (selectedStartDate && isSameDay(dayDate, selectedStartDate)) {
            dayElement.classList.add('start-date');
        }
        if (selectedEndDate && isSameDay(dayDate, selectedEndDate)) {
            dayElement.classList.add('end-date');
        }
        if (selectedStartDate && selectedEndDate && isInRange(dayDate, selectedStartDate, selectedEndDate)) {
            dayElement.classList.add('in-range');
        }
        
        // Event listener para selección
        dayElement.addEventListener('click', () => selectDate(dayDate));
        
        return dayElement;
    }
    
    function selectDate(date) {
        if (!selectedStartDate || (selectedStartDate && selectedEndDate)) {
            // Primera selección o reiniciar
            selectedStartDate = date;
            selectedEndDate = null;
            isSelectingEndDate = true;
        } else if (isSelectingEndDate) {
            // Segunda selección
            if (date < selectedStartDate) {
                selectedEndDate = selectedStartDate;
                selectedStartDate = date;
            } else {
                selectedEndDate = date;
            }
            isSelectingEndDate = false;
        }
        
        updateDateInputs();
        updateDateDisplay();
        renderCalendar();
        
        // Actualizar filtros del configurador
        if (typeof actualizarFiltros === 'function') {
            actualizarFiltros();
        }
    }
    
    function updateDateInputs() {
        const fechaDesdeInput = document.getElementById('fecha-desde');
        const fechaHastaInput = document.getElementById('fecha-hasta');
        
        if (fechaDesdeInput && selectedStartDate) {
            fechaDesdeInput.value = formatDateForInput(selectedStartDate);
        }
        if (fechaHastaInput && selectedEndDate) {
            fechaHastaInput.value = formatDateForInput(selectedEndDate);
        }
    }
    
    function updateDateDisplay() {
        const fechaDesdeDisplay = document.getElementById('fecha-desde-display');
        const fechaHastaDisplay = document.getElementById('fecha-hasta-display');
        
        if (fechaDesdeDisplay) {
            fechaDesdeDisplay.textContent = selectedStartDate ? formatDateForDisplay(selectedStartDate) : '-';
        }
        if (fechaHastaDisplay) {
            fechaHastaDisplay.textContent = selectedEndDate ? formatDateForDisplay(selectedEndDate) : '-';
        }
    }
    
    function formatDateForInput(date) {
        return date.toISOString().split('T')[0];
    }
    
    function formatDateForDisplay(date) {
        return date.toLocaleDateString('es-ES', { 
            day: 'numeric', 
            month: 'short' 
        });
    }
    
    function isSameDay(date1, date2) {
        return date1.getFullYear() === date2.getFullYear() &&
               date1.getMonth() === date2.getMonth() &&
               date1.getDate() === date2.getDate();
    }
    
    function isInRange(date, startDate, endDate) {
        return date > startDate && date < endDate;
    }
    
    // Event listeners para navegación
    document.getElementById('prev-month')?.addEventListener('click', () => {
        currentDate.setMonth(currentDate.getMonth() - 1);
        renderCalendar();
    });
    
    document.getElementById('next-month')?.addEventListener('click', () => {
        currentDate.setMonth(currentDate.getMonth() + 1);
        renderCalendar();
    });
    
    // Renderizar calendario inicial
    renderCalendar();
}

// === WIZARD CONFIGURADOR ===

let wizardCurrentStep = 1;
let wizardSelections = {
    tipo_viaje: '',
    estacion: '',
    categorias: []
};

// Función para obtener parámetros de URL
function getURLParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}

function inicializarWizard() {
    // Leer parámetros de URL para preseleccionar
    const tipoViajeURL = getURLParameter('tipo_viaje');
    const categoriaURL = getURLParameter('categoria');
    const estacionURL = getURLParameter('estacion');
    
    // Preseleccionar desde URL
    if (tipoViajeURL) {
        wizardSelections.tipo_viaje = tipoViajeURL;
        const btn = document.querySelector(`[data-tipo="${tipoViajeURL}"]`);
        if (btn) btn.classList.add('selected');
        document.getElementById('wizard-next-1').disabled = false;
    }
    
    if (estacionURL) {
        wizardSelections.estacion = estacionURL;
        const btn = document.querySelector(`[data-estacion="${estacionURL}"]`);
        if (btn) btn.classList.add('selected');
    }
    
    if (categoriaURL) {
        wizardSelections.categorias = [categoriaURL];
        const btn = document.querySelector(`[data-categoria="${categoriaURL}"]`);
        if (btn) btn.classList.add('selected');
    }
    
    // Si hay preselecciones, avanzar al paso correspondiente
    if (tipoViajeURL && estacionURL && categoriaURL) {
        // Ir al paso 3 (categorías)
        wizardGoToStep(3);
        document.getElementById('wizard-finish').disabled = false;
    } else if (tipoViajeURL && estacionURL) {
        // Ir al paso 3 (categorías)
        wizardGoToStep(3);
    } else if (tipoViajeURL) {
        // Ir al paso 2 (estación)
        wizardGoToStep(2);
    }
    
    // Event listeners para botones de tipo de viaje
    document.querySelectorAll('[data-tipo]').forEach(btn => {
        btn.addEventListener('click', function() {
            // Limpiar selección anterior
            document.querySelectorAll('[data-tipo]').forEach(b => b.classList.remove('selected'));
            // Seleccionar actual
            this.classList.add('selected');
            wizardSelections.tipo_viaje = this.dataset.tipo;
            // Habilitar botón siguiente
            document.getElementById('wizard-next-1').disabled = false;
        });
    });
    
    // Event listeners para botones de estación
    document.querySelectorAll('[data-estacion]').forEach(btn => {
        btn.addEventListener('click', function() {
            // Limpiar selección anterior
            document.querySelectorAll('[data-estacion]').forEach(b => b.classList.remove('selected'));
            // Seleccionar actual
            this.classList.add('selected');
            wizardSelections.estacion = this.dataset.estacion;
            // Habilitar botón siguiente
            document.getElementById('wizard-next-2').disabled = false;
        });
    });
    
    // Event listeners para botones de categoría (múltiple selección)
    document.querySelectorAll('[data-categoria]').forEach(btn => {
        btn.addEventListener('click', function() {
            const categoria = this.dataset.categoria;
            
            if (this.classList.contains('selected')) {
                // Deseleccionar
                this.classList.remove('selected');
                wizardSelections.categorias = wizardSelections.categorias.filter(c => c !== categoria);
            } else {
                // Seleccionar
                this.classList.add('selected');
                wizardSelections.categorias.push(categoria);
            }
            
            // Habilitar/deshabilitar botón finalizar
            document.getElementById('wizard-finish').disabled = wizardSelections.categorias.length === 0;
        });
    });
    
    // Event listeners para navegación
    document.getElementById('wizard-next-1')?.addEventListener('click', () => wizardGoToStep(2));
    document.getElementById('wizard-next-2')?.addEventListener('click', () => wizardGoToStep(3));
    document.getElementById('wizard-back-2')?.addEventListener('click', () => wizardGoToStep(1));
    document.getElementById('wizard-back-3')?.addEventListener('click', () => wizardGoToStep(2));
    
    // Event listener para finalizar
    document.getElementById('wizard-finish')?.addEventListener('click', function() {
        console.log('Wizard finish clicked with selections:', wizardSelections);
        
        // Crear objeto de filtros para el configurador
        const filtrosParaConfigurador = {
            tipo_viaje: wizardSelections.tipo_viaje,
            estacion: wizardSelections.estacion,
            categorias: [...wizardSelections.categorias]
        };
        
        // Si existe la función actualizarFiltros del configurador original, usarla
        if (typeof actualizarFiltros === 'function') {
            console.log('Using existing actualizarFiltros function');
            // Asignar a la variable global si existe
            if (typeof filtrosActivos !== 'undefined') {
                filtrosActivos = filtrosParaConfigurador;
                console.log('Updated filtrosActivos:', filtrosActivos);
            }
            actualizarFiltros();
        } else {
            console.log('actualizarFiltros not found, making direct AJAX call');
            
            // Verificar si existe el nonce
            console.log('Nonce available:', window.configurador_vars?.nonce);
            
            // Si no, hacer la petición AJAX directamente
            const requestData = {
                action: 'configurador_get_results',
                _ajax_nonce: window.configurador_vars?.nonce || '',
                tipo_viaje: wizardSelections.tipo_viaje,
                estacion: wizardSelections.estacion,
                categorias: JSON.stringify(wizardSelections.categorias)
            };
            
            console.log('Making AJAX request with data:', requestData);
            
            fetch('/wp-admin/admin-ajax.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams(requestData)
            })
            .then(response => {
                console.log('AJAX response status:', response.status);
                return response.json();
            })
            .then(data => {
                console.log('AJAX response data:', data);
                if (data.success) {
                    // Mostrar resultados
                    const resultadosContainer = document.getElementById('configurador-resultados');
                    console.log('Results container found:', resultadosContainer);
                    if (resultadosContainer) {
                        const htmlContent = data.data.html || '<p>No se encontraron resultados.</p>';
                        console.log('Setting HTML content:', htmlContent);
                        resultadosContainer.innerHTML = htmlContent;
                    }
                } else {
                    console.error('AJAX request failed:', data);
                }
            })
            .catch(error => {
                console.error('Error al obtener resultados:', error);
            });
        }
        
        // Scroll hacia los resultados
        const resultadosSection = document.getElementById('configurador-resultados');
        if (resultadosSection) {
            resultadosSection.scrollIntoView({ behavior: 'smooth' });
        }
    });
}

function wizardGoToStep(step) {
    console.log('wizardGoToStep called with step:', step);
    
    // Ocultar todos los pasos
    const allSteps = document.querySelectorAll('.wizard-step');
    console.log('Found wizard steps:', allSteps.length);
    allSteps.forEach(s => s.classList.remove('active'));
    
    // Mostrar paso actual
    const currentStepEl = document.querySelector(`.wizard-step[data-step="${step}"]`);
    console.log('Current step element:', currentStepEl);
    if (currentStepEl) {
        currentStepEl.classList.add('active');
        console.log('Added active class to step', step);
    } else {
        console.error('Step element not found for step:', step);
    }
    
    // Actualizar indicador de progreso
    document.querySelectorAll('.wizard-progress-step').forEach((indicator, index) => {
        const stepNumber = index + 1;
        indicator.classList.remove('active', 'completed');
        
        if (stepNumber < step) {
            indicator.classList.add('completed');
        } else if (stepNumber === step) {
            indicator.classList.add('active');
        }
    });
    
    wizardCurrentStep = step;
}

// Inicializar wizard si existe
if (document.getElementById('configurador-wizard')) {
    inicializarWizard();
}

// Funcionalidad de deslizamiento con mouse para galerías
function inicializarDeslizamientoMouse() {
    const galeriasDeslizables = document.querySelectorAll('.deslizamiento');
    
    galeriasDeslizables.forEach(galeria => {
        let isDown = false;
        let startX;
        let scrollLeft;
        let hasMoved = false;
        let velocity = 0;
        let lastX = 0;
        let animationId = null;
        
        // Aplicar scroll suave nativo
        galeria.style.scrollBehavior = 'auto';
        
        // Aplicar cursor grab a toda la galería y sus elementos
        galeria.style.cursor = 'grab';
        
        // Aplicar cursor grab también a todos los elementos hijos (incluyendo enlaces)
        const todosLosElementos = galeria.querySelectorAll('*');
        todosLosElementos.forEach(elemento => {
            elemento.style.cursor = 'grab';
        });
        
        // Función para animar el scroll suavemente
        function smoothScroll() {
            if (Math.abs(velocity) > 0.1) {
                galeria.scrollLeft += velocity;
                velocity *= 0.95; // Fricción
                animationId = requestAnimationFrame(smoothScroll);
            }
        }
        
        galeria.addEventListener('mousedown', (e) => {
            isDown = true;
            hasMoved = false;
            velocity = 0;
            
            if (animationId) {
                cancelAnimationFrame(animationId);
            }
            
            // Cambiar cursor a grabbing para toda la galería
            galeria.style.cursor = 'grabbing';
            todosLosElementos.forEach(elemento => {
                elemento.style.cursor = 'grabbing';
            });
            
            startX = e.pageX;
            lastX = e.pageX;
            scrollLeft = galeria.scrollLeft;
            
            // Prevenir selección de texto
            e.preventDefault();
        });
        
        galeria.addEventListener('mouseleave', () => {
            if (isDown && Math.abs(velocity) > 1) {
                smoothScroll();
            }
            isDown = false;
            galeria.style.cursor = 'grab';
            todosLosElementos.forEach(elemento => {
                elemento.style.cursor = 'grab';
            });
        });
        
        galeria.addEventListener('mouseup', () => {
            if (isDown && Math.abs(velocity) > 1) {
                smoothScroll();
            }
            isDown = false;
            galeria.style.cursor = 'grab';
            todosLosElementos.forEach(elemento => {
                elemento.style.cursor = 'grab';
            });
        });
        
        galeria.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            
            const currentX = e.pageX;
            const deltaX = currentX - lastX;
            
            // Calcular velocidad para inercia (mejorada para movimientos rápidos)
            velocity = deltaX * 1.2;
            
            // Aplicar scroll basado en el delta, no en la posición inicial
            galeria.scrollLeft -= deltaX;
            
            // Marcar como movido si hay desplazamiento significativo
            if (Math.abs(deltaX) > 2) {
                hasMoved = true;
            }
            
            lastX = currentX;
        });
        
        // Prevenir clicks en enlaces si se ha hecho drag
        galeria.addEventListener('click', (e) => {
            if (hasMoved) {
                e.preventDefault();
                e.stopPropagation();
            }
        }, true);
        
        // Prevenir el comportamiento de arrastrar imágenes
        galeria.addEventListener('dragstart', (e) => {
            e.preventDefault();
        });
        
        // Prevenir context menu en mobile
        galeria.addEventListener('contextmenu', (e) => {
            e.preventDefault();
        });
        
        // Resetear hasMoved después de un breve delay para permitir clicks normales
        galeria.addEventListener('mouseup', () => {
            setTimeout(() => {
                hasMoved = false;
            }, 150);
        });
    });
}

// Inicializar deslizamiento cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', inicializarDeslizamientoMouse);

// Sincronización de menús móviles
document.addEventListener('DOMContentLoaded', function() {
    const mobileMenuButton = document.querySelector('[data-collapse-toggle="mobile-menu-full"]');
    const mobileMenu = document.getElementById('mobile-menu-full');
    const dropdowns = ['search-dropdown', 'que-hacer-dropdown', 'gastronomia-dropdown', 'viaje-dropdown'];
    const allMenus = ['mobile-menu-full', ...dropdowns];
    
    // Prevenir scroll de página cuando hay menú abierto en móvil
    function preventBodyScroll(prevent) {
        if (window.innerWidth <= 1024) {
            if (prevent) {
                document.body.style.overflow = 'hidden';
                document.body.style.position = 'fixed';
                document.body.style.width = '100%';
            } else {
                document.body.style.overflow = '';
                document.body.style.position = '';
                document.body.style.width = '';
            }
        }
    }
    
    // Función para cerrar todos los menús excepto el especificado
    function closeAllMenusExcept(keepOpenId = null) {
        let hasOpenMenu = false;
        
        allMenus.forEach(menuId => {
            const menu = document.getElementById(menuId);
            if (menu && menuId !== keepOpenId) {
                menu.classList.add('hidden');
                
                // Resetear aria-expanded del botón correspondiente
                if (menuId === 'mobile-menu-full' && mobileMenuButton) {
                    mobileMenuButton.setAttribute('aria-expanded', 'false');
                } else {
                    const button = document.querySelector(`[data-dropdown-toggle="${menuId}"]`);
                    if (button) {
                        button.setAttribute('aria-expanded', 'false');
                    }
                }
            } else if (menu && menuId === keepOpenId && !menu.classList.contains('hidden')) {
                hasOpenMenu = true;
            }
        });
        
        // Controlar scroll según si hay algún menú abierto
        preventBodyScroll(hasOpenMenu);
    }
    
    // Observer para todos los menús
    allMenus.forEach(menuId => {
        const menu = document.getElementById(menuId);
        if (menu) {
            const observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        const isHidden = menu.classList.contains('hidden');
                        if (!isHidden) {
                            // Si este menú se abre, cerrar todos los demás
                            closeAllMenusExcept(menuId);
                        }
                    }
                });
            });
            observer.observe(menu, { attributes: true, attributeFilter: ['class'] });
        }
    });
    
    // Listener para todos los botones de dropdown
    document.querySelectorAll('[data-dropdown-toggle]').forEach(button => {
        button.addEventListener('click', function() {
            const targetId = this.getAttribute('data-dropdown-toggle');
            closeAllMenusExcept(targetId);
        });
    });
    
    // Listener especial para el menú móvil
    if (mobileMenuButton) {
        mobileMenuButton.addEventListener('click', function() {
            const isMenuHidden = mobileMenu.classList.contains('hidden');
            if (isMenuHidden) {
                closeAllMenusExcept('mobile-menu-full');
            } else {
                closeAllMenusExcept(null);
            }
        });
    }
});

// DSS EASE - Efecto de aparición global para elementos con clase .dss-ease
document.addEventListener('DOMContentLoaded', function() {
    
    // Función para verificar si un elemento debe aparecer
    function checkDssEaseItems() {
        const items = document.querySelectorAll('.dss-ease:not(.visible)');
        
        if (items.length === 0) return;
        
        items.forEach(function(item) {
            // Calcular posición del elemento
            const itemTop = item.offsetTop;
            const windowScrollTop = window.pageYOffset;
            const windowHeight = window.innerHeight;
            
            // Lógica para que aparezca cuando el elemento esté casi completamente visible
            if (itemTop < windowScrollTop + windowHeight - 200) {
                item.classList.add('visible');
                
                // Debug opcional
                if (window.location.search.includes('debug=dss-ease')) {
                    console.log('DSS Ease: Item appearing:', item);
                }
            }
        });
    }
    
    // Inicializar elementos - verificar inmediatamente al cargar
    function initDssEaseItems() {
        // Verificar inmediatamente al cargar
        checkDssEaseItems();
    }
    
    // Throttle para hacer el scroll más suave
    let scrollTimeout;
    function throttledCheck() {
        if (scrollTimeout) return;
        scrollTimeout = setTimeout(function() {
            checkDssEaseItems();
            scrollTimeout = null;
        }, 50); // ~20fps para ser menos agresivo
    }
    
    // Eventos de scroll y load
    window.addEventListener('scroll', throttledCheck);
    window.addEventListener('load', checkDssEaseItems);
    
    // Inicializar
    initDssEaseItems();
});
